var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pt-0"},[_c('v-row',[_c('ReviewField',{attrs:{"data-testid":"residentialAddress","sm":"8","label":"Student’s Residential Address","value":_vm.residentialAddress}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }